module.exports = __webpack_public_path__ + "img/10_55.df2a9030.png";